import { useDispatch } from "react-redux";
import { useProfileVerifyEmailMutation } from "../../../Store/Builder/techsbook.api";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import showToast from "../../Hooks/toast";
import useGetAccountApi from "../Account/getAccountApi";

const useVerifyEmailApi = () => {
  const dispatch = useDispatch();
  const [verifyEmail] = useProfileVerifyEmailMutation();
  const getAccountApi = useGetAccountApi();
  const send = (body, setModal) => {
    dispatch(setLoader(true));
    verifyEmail(body)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        showToast(res?.message ?? "Success", "success");
        setModal(false);
        getAccountApi.get();
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  return {
    send,
  };
};

export default useVerifyEmailApi;
